module.exports = __webpack_public_path__ + "static/media/M124ws.6a80c639.pdf";